import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '@shared/services/api.service';
import { FcmApiPayload } from '../models/fcm-api.model';
import { UserApi } from '../models/user-api.model';
import { User } from '../models/user.model';
import { UserCreateApiPayload } from '../models/user-create-api.model';
import { UserUpdateApiPayload } from '../models/user-update-api.model';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {

  static apiContext = 'customers';
  static userResourcePath = 'me';
  static fcmResourcePath = 'fcm';

  private _apiService = inject(ApiService);

  register$(payload: UserCreateApiPayload): Observable<User | null> {
    return this._apiService
               .post<UserApi>({
                 url: UserApiService.apiContext,
                 body: payload,
               })
               .pipe(
                   map((item) => item ? new User(item) : null),
               );
  }

  getMe$(): Observable<User | null> {
    return this._apiService
               .get<UserApi>(`${ UserApiService.apiContext }/${ UserApiService.userResourcePath }`)
               .pipe(
                   map((item) => item ? new User(item) : null),
               );
  }

  update$(payload: UserUpdateApiPayload): Observable<User | null> {
    return this._apiService
               .put<UserApi>({
                 url: `${ UserApiService.apiContext }/${ UserApiService.userResourcePath }`,
                 body: payload,
               })
               .pipe(
                   map((item) => item ? new User(item) : null),
               );
  }

  delete$(): Observable<void | null> {
    return this._apiService.delete<void>({
      url: `${ UserApiService.apiContext }/${ UserApiService.userResourcePath }`,
    });
  }

  registerFcm$(payload: FcmApiPayload): Observable<void | null> {
    return this._apiService.post<void>({
      url: `${ UserApiService.apiContext }/${ UserApiService.fcmResourcePath }`,
      body: payload,
    });
  }

  deleteFcm$(): Observable<void | null> {
    return this._apiService
               .post<void>({
                 url: `${ UserApiService.apiContext }/${ UserApiService.fcmResourcePath }`,
                 // TODO request with null
                 body: { fcm: null },
               });
  }
}
